export default {"src":"/_next/static/image/src/images/Homepage/logo.77a76e0aec971b04d749bbf44b646524.svg","height":231,"width":469};